import * as React from "react";
import { observer } from "mobx-react";
import { BetButtonsWrapMultiview } from "../BetButtonsWrapMultiview";
export const MarketsWrapMultiview = observer((props) => {
    const buttonsHolderClass = props.details.event.cardType
        ? `rj-ev-list__${props.componentPrefix}__buttons-holder--${props.details.event.cardType.toLowerCase()}`
        : "";
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${props.componentPrefix}-buttons-holder` }, props.details.markets.map((market, index) => {
        return React.createElement(BetButtonsWrapMultiview, { key: `${props.componentPrefix}__${market.id}-${index}`, details: props.details, market: market, componentPrefix: props.componentPrefix });
    })));
});
//# sourceMappingURL=MarketsWrapMultiview.js.map